
export default function BookingProcess() {
  const navigate = () => {
    if (window.REACT_APP_NAVIGATE) {
      window.REACT_APP_NAVIGATE('/booking');
    }
  };

  const steps = [
    {
      number: '01',
      icon: 'ri-search-line',
      title: '원하는 서비스 선택',
      description: '네일, 속눈썹, 피부관리 등 원하는 뷰티 서비스를 선택하세요',
      color: 'from-rose-400 to-pink-400'
    },
    {
      number: '02',
      icon: 'ri-calendar-check-line',
      title: '디자이너 & 예약 시간 선택',
      description: '마음에 드는 디자이너와 편한 시간을 선택하세요',
      color: 'from-pink-400 to-purple-400'
    },
    {
      number: '03',
      icon: 'ri-notification-line',
      title: '예약 완료 및 알림받기',
      description: '예약이 완료되면 카카오톡으로 알림을 받으실 수 있어요',
      color: 'from-purple-400 to-rose-400'
    }
  ];

  return (
    <section id="booking" className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-light text-gray-800 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            How to Book
          </h2>
          <p className="text-base text-gray-600">간편한 3단계로 예약을 완료하세요</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-20 left-1/2 w-full h-0.5 bg-gradient-to-r from-rose-200 to-pink-200 z-0"></div>
              )}
              
              <div className="relative z-10 text-center">
                <div className={`w-20 h-20 flex items-center justify-center mx-auto mb-6 rounded-full bg-gradient-to-br ${step.color} shadow-lg`}>
                  <i className={`${step.icon} text-3xl text-white`}></i>
                </div>
                
                <div className="text-5xl font-light text-gray-200 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
                  {step.number}
                </div>
                
                <h3 className="text-xl font-medium text-gray-800 mb-3">{step.title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed px-4">{step.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-br from-rose-50 to-pink-50 rounded-3xl p-12 text-center">
          <h3 className="text-2xl font-medium text-gray-800 mb-4">지금 바로 시작하세요</h3>
          <p className="text-base text-gray-600 mb-8">나만의 뷰티 시간을 예약하고 더 예쁜 나를 만나보세요</p>
          <button 
            onClick={navigate}
            className="px-10 py-4 bg-gradient-to-r from-rose-400 to-pink-400 text-white text-base font-medium rounded-full hover:shadow-2xl hover:scale-105 transition-all whitespace-nowrap cursor-pointer"
          >
            예약 시작하기
          </button>
        </div>
      </div>
    </section>
  );
}
